<template>
  <div class="row shadowed">
    <div class="col">
      <h5>
        Made with <a
          href="https://vuejs.org/"
          target="_blank"
        >VueJS</a> - <span @click="goToCredits">Crédits</span> - version: {{ version }}
      </h5>
    </div>
  </div>
</template>

<script>
import { version } from '../../package.json';

  export default {
    name: 'Footer',
    data() {
        return {
            version,
        };
    },
    methods: {
      goToCredits() {
        this.$router.push({ name: 'credits' });
      }
    }
  };
</script>

<style scoped>
    .row {
        height: 50px;
        border-top: 2px solid darkorange;
        justify-content: center;
    }

    .shadowed {
        -moz-box-shadow: 0 -1px 6px 0 rgba(32, 33, 36, 0.28);
        -webkit-box-shadow: 0 -1px 6px 0 rgba(32, 33, 36, 0.28);
        -o-box-shadow: 0 -1px 6px 0 rgba(32, 33, 36, 0.28);
        box-shadow: 0 -1px 6px 0 rgba(32, 33, 36, 0.28);
        filter: progid:DXImageTransform.Microsoft.Shadow(color=#1F2124, Direction=-180, Strength=6);
    }

    .col {
        justify-content: center;
    }

    h5 {
        margin: 0;
        padding: 0;
    }

    .col a {
        color: inherit;
    }
</style>
